import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const LoadingMessageWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '.MuiCircularProgress-root': {
    marginRight: 12,
    color: theme.palette.text.secondary,
  },
  p: {
    marginTop: 0,
    marginBottom: 0,
    fontSize: 15,
  },
}));

const AccountInfoLoadingMessage = () => (
  <LoadingMessageWrapper>
    <CircularProgress size={18} />
    <p>
      <FormattedMessage id="portfolio.challenge.files.add.connected_accounts_dialog.account_settings.loading_message" />
    </p>
  </LoadingMessageWrapper>
);

export default AccountInfoLoadingMessage;
